import { TextField, Typography } from "@mui/material";
import styled from "@emotion/styled";

// EDIT BY ALI FOR DARK MODE - Updated TextFieldStyled to use theme colors
export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  border: `1px solid ${theme.palette.mode === "dark" ? "#444444" : "#D7DBDD"}`,
  borderRadius: "6px",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "18px",
  color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.9)" : "rgba(88, 89, 91, 0.48)",
  // Design-system border lives on the root; hide MUI fieldset to avoid a double outline.
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

// EDIT BY ALI FOR DARK MODE - Updated HideStyled to use theme colors
export const HideStyled = styled(Typography)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#000000",
}));
